import { render } from "./FirstTime.vue?vue&type=template&id=ffca1478&scoped=true"
import script from "./FirstTime.vue?vue&type=script&lang=js"
export * from "./FirstTime.vue?vue&type=script&lang=js"

import "./FirstTime.vue?vue&type=style&index=0&id=ffca1478&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ffca1478"

export default script